module.exports = __webpack_public_path__ + "static/9-7d93d06fd2d485c3a34aed72841d35cd.jpg";